import WordCloud from '@aytm/app/stats/page/question-views/components/word-cloud/WordCloud'

// The cloud surface for every type whose cloud stands alone. The cloud owns its own corpus
// processing, controls, loading frame and words table, so this view only hands the marshalled
// bag through -- combo replaces the view because its cloud carries a scope table under it.
const WordCloudView = props => <WordCloud {...props} />

WordCloudView.displayName = 'OeWordCloudView'

export default WordCloudView
